import styled from "styled-components";

// The global button reset drops the outline, so every copy trigger in the
// app gets its focus ring from here.
export const CopyToClipboardButton = styled.button`
  padding: 4px 6px 2px 0;
  border-radius: 4px;

  &:focus-visible {
    box-shadow: 0 0 0 3px ${({ theme }) => theme.focusRing};
  }
`;
